import { findKey } from "lodash";
import { useCallback } from "react";
import { defineMessages } from "react-intl";
import { useDispatch } from "react-redux";
import { updateSortOrder } from "../../../../reducers/resourcesList/sortOrder";

import { useFormatMessage } from "../../../Intl/Context";
import { useResourcesList } from "../../../ResourcesList/resourcesList";

const ContributionsDatavizSearchSort = () => {
  const t = useFormatMessage();
  const sortByLabel = t(intlMessages.sortBy);
  const sortByNewerLabel = t(intlMessages.sortByNewer);
  const sortByOlderLabel = t(intlMessages.sortByOlder);

  const { resourcesListKey, sortOrder } = useResourcesList();

  const sortOptions = {
    newer: {
      value: "newer",
      field: "publishedAt",
      direction: "desc",
      label: sortByNewerLabel
    },
    older: {
      value: "older",
      field: "publishedAt",
      direction: "asc",
      label: sortByOlderLabel
    }
  };

  const isSelected = useCallback(
    ({ field, direction }) =>
      sortOrder.field === field && sortOrder.direction === direction,
    [sortOrder.direction, sortOrder.field]
  );

  const dispatch = useDispatch();
  const handleSortOrderChanged = ({ target }) => {
    const option = sortOptions[target.value];
    if (isSelected(option)) return;

    dispatch(updateSortOrder(resourcesListKey, option.field, option.direction));
  };

  // Find the currently selected value to provide it to the <select> tag
  const selectValue = findKey(sortOptions, isSelected);

  return (
    <div>
      <label className="mr-1" htmlFor="selectSortBy">
        {sortByLabel}
      </label>
      <div className="selectWrapper d-inline-block text-primary">
        <select
          id="selectSortBy"
          className="text-primary pointer"
          onChange={handleSortOrderChanged}
          value={selectValue}
        >
          {Object.values(sortOptions).map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ContributionsDatavizSearchSort;

const intlMessages = defineMessages({
  sortBy: {
    id: "contributions.dataviz.search.sort.sortBy",
    defaultMessage: "Trier par"
  },
  sortByNewer: {
    id: "contributions.dataviz.search.sort.sortByNewer",
    defaultMessage: "+ récent"
  },
  sortByOlder: {
    id: "contributions.dataviz.search.sort.sortByOlder",
    defaultMessage: "+ ancien"
  }
});
